// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated
import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { ProcessChainSchema } from '../../entities/process-chain/process-chain.schema';
// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated
/**
 * Edit Process Chain Request Schema
 * PUT /api/v2/process-chains/:id
 * All fields from create are optional for partial updates, with nullable support for clearing fields
 */ export const EditProcessChainRequestSchema = ProcessChainSchema.omit({
    _id: true,
    createdBy: true,
    createdAt: true,
    updatedAt: true
}).partial().extend({
    description: z.string().nullable().optional(),
    departmentName: z.string().nullable().optional(),
    e2eLabel: z.string().nullable().optional(),
    typicalInputs: z.array(z.string()).nullable().optional()
});
/**
 * Edit Process Chain Response Schema
 */ export const EditProcessChainResponseSchema = z.object({
    processChain: ProcessChainSchema
});
export const EditProcessChainErrorSchema = BaseErrorSchema;

//# sourceMappingURL=edit-process-chain.schema.js.map